import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
export class NumberHelper {
  static getRnd() {
    var min = Math.ceil(100000);
    var max = Math.floor(10000000000);
    return (Math.floor(Math.random() * (max - min + 1)) + min).toString();
  }

}